import { Menu } from '@time-line/components/common';
import { Globe } from '@time-line/components/icons';
import { useGlobals } from 'hooks/useGlobals';
import {
  useLocalStorage,
  UserLocale,
  UserLocalePreference,
} from 'hooks/userPreferences';
import { useRouter } from 'next/router';
import type { Country } from 'types/cms/Country';
import { mapCountryToLocale } from 'utils/mappers/mapCountryToLocale';

interface CountrySelectorProps {
  variant?: 'primary' | 'overline';
  showFullName?: boolean;
}

export function CountrySelector({
  variant = 'primary',
  showFullName = false,
}: CountrySelectorProps) {
  const { data: globals } = useGlobals();
  const router = useRouter();

  const { value: userSiteLocale, setStoredValue: setUserSiteLocale } =
    useLocalStorage(UserLocale);

  const { setStoredValue: setUserLocalePreference } =
    useLocalStorage(UserLocalePreference);

  if (!globals) {
    return null;
  }

  const handleMenuItemClick = (item: Country) => {
    setUserSiteLocale(mapCountryToLocale(item));
    setUserLocalePreference({ hasSetLocale: true });
    router.reload();
  };

  return (
    <Menu
      leftIcon={<Globe />}
      menuItems={globals.availableCountries}
      renderButton={(item) => (showFullName ? item.name : item.isoCode)}
      renderItem={(item) => `${item.name} (${item.currency.isoCode})`}
      selectedItem={globals.availableCountries.find(
        (country) => country.isoCode === userSiteLocale.countryCode,
      )}
      onChange={(item) => handleMenuItemClick(item)}
      variant={variant}
      size="sm"
    />
  );
}
